import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { generateKitNumber } from '../services/SprinklerSamplingService';
import { NAMESPACE } from '../constants';
export function useGenerateKitNumberMutation() {
    return useMutation({
        mutationFn: (buildingId) => generateKitNumber(buildingId),
        onError: (error) => {
            toast.error(error.message || translate('form.errors.generate_kit_number_failed', { namespace: NAMESPACE }));
        }
    });
}
